import styled from 'styled-components';

import uploadBg from '~/assets/img/upload-bg.png';

export const Container = styled.div`
  width: 365px;
  height: 249px;
  margin: 0 auto;
  border-radius: 8px;
  border: dashed 2px #5a9fb0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    input {
      display: none;
    }
    label {
      background-image: url(${uploadBg});
      background-repeat: no-repeat;
      background-position: center 40px;
      display: block;
      width: 365px;
      height: 249px;
      cursor: pointer;
      position: absolute;
      color: #ffffff;
    }
    span.fileUploadText {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.13;
      letter-spacing: 0.01px;
      text-align: center;
      color: #6c6c6c;
      display: block;
      position: relative;
      top: 150px;
    }
  }
`;
